import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import SelectedOGItem from "./SelectedOGItem";

interface Props {
  ceId: string;
  ceTexto: string;
  objetivos: Record<string, { id: string; texto: string }>;
  onRemoveOG: (ogId: string) => void;
}

const SelectedCEBlock: React.FC<Props> = ({ ceTexto, objetivos, onRemoveOG }) => {
  const ogEntries = Object.entries(objetivos ?? {});
  return (
    <Box sx={{ mb: 1.2 }}>
      <Typography
        sx={{
          fontFamily: "Montserrat",
          fontSize: "0.7rem",
          fontWeight: 700,
          color: "rgba(0,0,0,0.60)",
          mb: 0.8,
          ml: 1,
        }}
      >
        CRITERIO DE EVALUACIÓN
      </Typography>

      <Typography
        sx={{
          fontFamily: "Montserrat",
          fontSize: "0.7rem",
          fontWeight: 400,
          color: "rgba(0,0,0,0.6)",
          mb: 0.6,
          ml: 1,
          lineHeight: 1.25,
        }}
      >
        {ceTexto}
      </Typography>

      <Stack spacing={0.6}>
        <Typography
          sx={{
            fontFamily: "Montserrat",
            fontSize: "0.7rem",
            fontWeight: 700,
            color: "rgba(0,0,0,0.60)",
            mt: 0.8,
            pl: 2,
          }}
        >
          OBJETIVO GENÉRICO
        </Typography>

        {ogEntries.map(([ogId, og]) => (
          <SelectedOGItem
            key={ogId} 
            ogId={ogId} 
            texto={og.texto}
            onRemove={() => onRemoveOG(ogId)}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default SelectedCEBlock;
